import { render, staticRenderFns } from "./PicturesUpload.vue?vue&type=template&id=5c4d36ac&"
import script from "./PicturesUpload.vue?vue&type=script&lang=js&"
export * from "./PicturesUpload.vue?vue&type=script&lang=js&"
import style0 from "./PicturesUpload.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports